import { PaymentType } from '../enums/payment-type.enum';

export interface IDelay {
  paymentType: PaymentType;
  delay: string;
  formattedPaymentType?: string;
}
